import React, { PropsWithChildren } from 'react';

const FormWrapper = ({ children }: PropsWithChildren) => {
  return <React.Fragment>{children}</React.Fragment>;
};

export default FormWrapper;
